import { keysToCamelCase } from '@hotjar/webapp/lib/convert-string';
import axios from 'axios';
import type { SiteId } from '@hotjar/site';
import type { SessionsSettings } from './model';

const API_ROOT = `/api/v1/sites`;

export const getSessionSettings = async (siteId: SiteId): Promise<SessionsSettings> => {
  const response = await axios.get(`${API_ROOT}/${siteId}/settings/sessions`);

  return keysToCamelCase(response?.data);
};
